import { isMeetingScheduleMessage, isSMSNumberRequest, isSMSNumberSuccess } from 'modules/message/utils'
import { lazy } from 'react'
import { Message } from 'types/message'

import { LazyCard } from '../LazyCard'
import DefaultLazyMessage from '../LazyCard/Default'
import MeetingLazyCard from '../LazyCard/meeting'
import Default from './default'
import Html from './html'

const MESSAGE_TYPES = {
  'BOT': LazyCard(lazy(()=> import('./bot')),DefaultLazyMessage),
  'CONVO_RATING': LazyCard(lazy(() => import('./conversationRating')),DefaultLazyMessage),
  'EMAIL_CAPTURE': LazyCard(lazy(() => import('./emailCapture')),DefaultLazyMessage),
  'HTML': Html,
  'LEGACY': LazyCard(lazy(()=>import('./html')),DefaultLazyMessage),
  'MEETING': LazyCard(lazy(()=>import('./meeting')), MeetingLazyCard),
  'SMS_CAPTURE': LazyCard(lazy(()=>import('./sms/PhoneCaptureCard')),DefaultLazyMessage),
  'SMS_SUCCESS': LazyCard(lazy(()=> import('./sms/PhoneCaptureSuccessCard')),DefaultLazyMessage),
  'STRING': Default
}

export const resolveMessageComponent = (message: Message) => {
  const { isBot = false, show_email_capture_card, conversationRating }  = message.attributes

  if(show_email_capture_card) { return MESSAGE_TYPES.EMAIL_CAPTURE }
  if(isMeetingScheduleMessage(message)) { return MESSAGE_TYPES.MEETING }
  if(isBot) { return MESSAGE_TYPES.BOT }
  if(!!conversationRating) { return MESSAGE_TYPES.CONVO_RATING }
  if(isSMSNumberRequest(message)) { return MESSAGE_TYPES.SMS_CAPTURE }
  if(isSMSNumberSuccess(message)) { return MESSAGE_TYPES.SMS_SUCCESS }

  return MESSAGE_TYPES.HTML
}
